export default "__VITE_ASSET__3HtLH$HG__"